import styled from '@emotion/styled';
import { colorPalette } from 'styles/partials/colors';

export const Title = styled.span({
  color: colorPalette.darkGray1,
  fontSize: '16px',
  fontWeight: 500,
});

export const Subtitle = styled.span({
  color: colorPalette.darkGray1,
  fontSize: '14px',
  fontWeight: 500,
});

export const Caption = styled.span({
  color: colorPalette.darkGray1,
  fontSize: '12px',
});
